<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-card class="mx-auto text-center" max-width="265">
          <div class="pa-5 grey lighten-5" height="100%">
            <v-row align="end" class="fill-height">
              <v-col align-self="center" class="pa-0" cols="12">
                <v-avatar class="profile" size="164">
                  <v-img :src="require('../assets/avatar.png')" alt="John"></v-img>
                </v-avatar>
              </v-col>
            </v-row>
          </div>
          <v-card-title class="justify-center blue--text">Hi.</v-card-title>
          <v-card-subtitle class="pb-2">Im Marcus Ericsson</v-card-subtitle>

          <v-card-text class="text--primary">
            
            <div>Builder of things</div>
            <div>Fixer of stuff</div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn v-for="(social, i) in socialLinks" 
              :key="i" 
              :color="social.color" :href="social.href" target="_blank" icon>
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HelloWorld",

  data: () => ({
    socialLinks: [
      {
        icon: "mdi-linkedin",
        color: "blue",
        href: "https://www.linkedin.com/in/maericsson/",
      },
      {
        icon: "mdi-instagram",
        color: "pink",
        href: "https://www.instagram.com/marcusee/",
      },
      {
        icon: "mdi-xing",
        color: "green",
        href: "https://www.xing.com/profile/Marcus_Ericsson/cv",
      },
    ]
  }),
};
</script>
